import { render, staticRenderFns } from "./Epson.vue?vue&type=template&id=0bb40b2e&scoped=true&"
import script from "./Epson.vue?vue&type=script&lang=js&"
export * from "./Epson.vue?vue&type=script&lang=js&"
import style0 from "./Epson.vue?vue&type=style&index=0&id=0bb40b2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb40b2e",
  null
  
)

export default component.exports